module.exports = __webpack_public_path__ + "img/white-checked-tick.5b7d56c8.svg";